import type { RouteRecordRaw } from "vue-router";
import wayplusHero from "@/assets/images/wayplus/public/sub/wayplus/hero.png";
import technologyHero from "@/assets/images/wayplus/public/sub/technology/hero.png";
import supportHero from "@/assets/images/wayplus/public/sub/support/hero.png";
import serviceHero from "@/assets/images/wayplus/public/sub/service/hero.png";
import newsHero from "@/assets/images/wayplus/public/sub/news/hero.png";

const publicRoutes: RouteRecordRaw[] = [
  // 메인 홈
  {
    path: "/",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    children: [
      {
        path: "",
        name: "publicHome",
        component: () => import("@/views/public/PublicHome.vue"),
        meta: {
          title: "홈",
          description: "웨이플러스는 AI와 데이터 기술을 기반으로 스마트 관광과 DX 서비스를 제공합니다.",
          ogImage: wayplusHero,
          layoutType: "main"
        }
      }
    ]
  },
  // WAYHUB 서브사이트 (Vue 마이그레이션 — cutover 완료)
  // /wayhub 가 SPA. 기존 정적 사이트는 회귀 비교용으로 /wayhub-legacy/ 에 보존(vite wayhubLegacyStaticPlugin).
  // 내부 내비는 전부 name 기반이라 경로에 비의존적. 정적 HTML 자산(/wayhub/{css,js,assets})은 public 실파일로 공유.
  {
    path: "/wayhub",
    component: () => import("@/layouts/wayhub/WayhubLayout.vue"),
    children: [
      {
        path: "",
        name: "wayhubHome",
        component: () => import("@/views/wayhub/WayhubHome.vue"),
        meta: {
          title: "WayHub - HOME",
          description: "WayHub - QR 기반 스마트 관광 플랫폼. 단순한 관람을 넘어 몰입형 경험의 시작."
        }
      },
      {
        path: "solution",
        name: "wayhubSolution",
        component: () => import("@/views/wayhub/WayhubSolution.vue"),
        meta: { title: "WayHub - 솔루션소개" }
      },
      {
        path: "business",
        name: "wayhubBusiness",
        component: () => import("@/views/wayhub/WayhubBusiness.vue"),
        meta: { title: "WayHub - 도입효과" }
      },
      {
        path: "example",
        name: "wayhubExample",
        component: () => import("@/views/wayhub/WayhubExample.vue"),
        meta: { title: "WayHub - 적용 사례" }
      },
      {
        path: "portfolio/:id",
        name: "wayhubPortfolio",
        component: () => import("@/views/wayhub/WayhubPortfolio.vue"),
        props: true,
        meta: { title: "WayHub - 적용 사례" }
      }
    ]
  },
  // WAYPLUS (회사소개 카테고리)
  {
    path: "/wayplus",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: {
      title: "WAYPLUS",
      headerMenu: { name: "WAYPLUS", order: 1 },
      showSubNav: true,
      heroBgImage: wayplusHero
    },
    children: [
      {
        path: "",
        redirect: { name: "Intro" }
      },
      {
        path: "intro",
        name: "Intro",
        component: () => import("@/views/public/wayplus/Intro.vue"),
        meta: {
          title: "소개",
          description: "웨이플러스의 비전과 미션, 핵심 가치를 소개합니다.",
          ogImage: wayplusHero,
          layoutType: "sub",
          heroTitle: "WAYPLUS",
          heroSubtitle: "회사소개, 성장 스토리, 조직문화를 만나보세요.",
          headerSubMenu: true
        }
      },
      {
        path: "history",
        name: "History",
        component: () => import("@/views/public/wayplus/History.vue"),
        meta: {
          title: "연혁",
          description: "웨이플러스의 성장 스토리와 주요 연혁을 확인하세요.",
          ogImage: wayplusHero,
          layoutType: "sub",
          heroTitle: "WAYPLUS",
          heroSubtitle: "회사소개, 성장 스토리, 조직문화를 만나보세요.",
          headerSubMenu: true
        }
      },
      {
        path: "culture",
        name: "culture",
        component: () => import("@/views/public/wayplus/Culture.vue"),
        meta: {
          title: "문화",
          description: "웨이플러스의 조직 문화와 일하는 방식을 소개합니다.",
          ogImage: wayplusHero,
          layoutType: "sub",
          heroTitle: "WAYPLUS",
          heroSubtitle: "회사소개, 성장 스토리, 조직문화를 만나보세요.",
          headerSubMenu: true
        }
      }
    ]
  },
  // 기술
  {
    path: "/technology",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: {
      title: "기술",
      headerMenu: { name: "기술", order: 2 },
      showSubNav: true,
      heroBgImage: technologyHero
    },
    children: [
      {
        path: "",
        name: "publicTechAiTourism",
        component: () => import("@/views/public/technology/TechAiTourism.vue"),
        meta: {
          title: "AI관광",
          description: "AI 기술을 활용한 스마트 관광 솔루션과 사례를 확인하세요.",
          ogImage: technologyHero,
          layoutType: "sub",
          heroTitle: "기술",
          heroSubtitle: "AI와 데이터 기술을 기반으로 스마트 관광을 구현합니다.",
          headerSubMenu: true
        }
      },
      {
        path: "dx",
        name: "publicTechDx",
        component: () => import("@/views/public/technology/TechDx.vue"),
        meta: {
          title: "DX",
          description: "데이터 기반의 디지털 전환(DX) 서비스를 제공합니다.",
          ogImage: technologyHero,
          layoutType: "sub",
          heroTitle: "기술",
          heroSubtitle: "AI와 데이터 기술을 기반으로 스마트 관광을 구현합니다.",
          headerSubMenu: true
        }
      },
      {
        path: "consulting",
        name: "publicTechConsulting",
        component: () => import("@/views/public/technology/TechConsulting.vue"),
        meta: {
          title: "서비스 기획/컨설팅",
          description: "서비스 기획과 컨설팅으로 비즈니스 혁신을 돕습니다.",
          ogImage: technologyHero,
          layoutType: "sub",
          heroTitle: "기술",
          heroSubtitle: "AI와 데이터 기술을 기반으로 스마트 관광을 구현합니다.",
          headerSubMenu: true
        }
      }
    ]
  },
  // 서비스
  {
    path: "/service",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: {
      title: "서비스",
      headerMenu: { name: "서비스", order: 3 },
      showSubNav: true,
      heroBgImage: serviceHero,
      externalSubMenus: [
        {
          name: "웨이지니",
          externalLink: import.meta.env.VITE_WAYGENIE_LINK,
          order: 1
        },
        {
          name: "웨이허브",
          externalLink: import.meta.env.VITE_WAYHUB_LINK,
          order: 2,
          openInNewWindow: true
        },
        {
          name: "같이놀쟈",
          routeName: "publicSolutionTogether",
          order: 3,
          openInNewWindow: true
        }
      ]
    },
    children: [
      {
        path: "",
        redirect: { name: "publicServicePatents" }
      },
      {
        path: "patents",
        name: "publicServicePatents",
        component: () => import("@/views/public/service/ServicePatents.vue"),
        meta: {
          title: "특허서비스",
          description: "웨이플러스가 보유한 특허와 서비스 혁신 사례를 확인하세요.",
          ogImage: serviceHero,
          layoutType: "sub",
          heroTitle: "서비스",
          heroSubtitle: "다양한 플랫폼과 서비스 사례를 확인해보세요.",
          headerSubMenu: true,
          subMenuOrder: 4
        }
      },
      {
        path: "patents/:articleId",
        name: "publicServicePatentDetail",
        component: () => import("@/views/public/service/ServicePatentDetail.vue"),
        meta: {
          title: "특허서비스",
          description: "웨이플러스 특허 서비스 상세 정보.",
          ogImage: serviceHero,
          layoutType: "sub",
          heroTitle: "서비스",
          heroSubtitle: "다양한 플랫폼과 서비스 사례를 확인해보세요.",
          listRouteName: "publicServicePatents"
        }
      }
    ]
  },
  // 소식
  {
    path: "/news",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: {
      title: "소식",
      headerMenu: { name: "소식", order: 4 },
      showSubNav: true,
      heroBgImage: newsHero
    },
    children: [
      {
        path: "",
        redirect: { name: "publicNewsPressRelease" }
      },
      {
        path: "press-release",
        name: "publicNewsPressRelease",
        component: () => import("@/views/public/news/NewsPressRelease.vue"),
        meta: {
          title: "보도자료",
          description: "웨이플러스 최신 보도자료와 언론 보도를 확인하세요.",
          ogImage: newsHero,
          layoutType: "sub",
          heroTitle: "소식",
          heroSubtitle: "새로운 소식과 다양한 이야기를 확인하세요.",
          headerSubMenu: true,
          subMenuOrder: 1
        }
      },
      {
        path: "press-release/:articleId",
        name: "publicNewsPressReleaseDetail",
        component: () => import("@/views/public/news/NewsArticleDetail.vue"),
        meta: {
          title: "보도자료",
          description: "웨이플러스 보도자료 상세 내용.",
          ogImage: newsHero,
          layoutType: "sub",
          heroTitle: "소식",
          heroSubtitle: "새로운 소식과 다양한 이야기를 확인하세요.",
          listRouteName: "publicNewsPressRelease"
        }
      },
      {
        path: "company",
        name: "publicNewsCompany",
        component: () => import("@/views/public/news/NewsCompany.vue"),
        meta: {
          title: "사내소식",
          description: "웨이플러스의 사내 소식과 구성원 이야기를 전합니다.",
          ogImage: newsHero,
          layoutType: "sub",
          heroTitle: "소식",
          heroSubtitle: "새로운 소식과 다양한 이야기를 확인하세요.",
          headerSubMenu: true,
          subMenuOrder: 2
        }
      },
      {
        path: "company/:articleId",
        name: "publicNewsCompanyDetail",
        component: () => import("@/views/public/news/NewsArticleDetail.vue"),
        meta: {
          title: "사내소식",
          description: "웨이플러스 사내 소식 상세 내용.",
          ogImage: newsHero,
          layoutType: "sub",
          heroTitle: "소식",
          heroSubtitle: "새로운 소식과 다양한 이야기를 확인하세요.",
          listRouteName: "publicNewsCompany"
        }
      },
      {
        path: "awards",
        name: "publicNewsAwards",
        component: () => import("@/views/public/news/NewsAwards.vue"),
        meta: {
          title: "수상 및 인증",
          description: "웨이플러스가 받은 수상 및 인증 내역을 소개합니다.",
          ogImage: newsHero,
          layoutType: "sub",
          heroTitle: "소식",
          heroSubtitle: "새로운 소식과 다양한 이야기를 확인하세요.",
          headerSubMenu: true,
          subMenuOrder: 3
        }
      }
    ]
  },
  // 문의하기 (히어로 없음, 다크 배경 페이지)
  {
    path: "/contact",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: { headerMenu: { name: "문의하기", order: 5 } },
    children: [
      {
        path: "",
        name: "publicContact",
        component: () => import("@/views/public/contact/ContactMain.vue"),
        meta: {
          title: "문의하기",
          description: "웨이플러스에 문의하세요. 사업 제휴, 채용, 서비스 문의를 받습니다.",
          layoutType: "sub",
          headerSubMenu: true
        }
      }
    ]
  },
  // 지원사업
  {
    path: "/support",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: {
      headerMenu: { name: "지원사업", order: 6, type: "button" },
      heroBgImage: supportHero
    },
    children: [
      {
        path: "",
        name: "publicSupport",
        component: () => import("@/views/public/support/SupportMain.vue"),
        meta: {
          title: "지원사업",
          description: "웨이플러스와 함께하는 지원사업. 기업 성장을 위한 파트너십을 소개합니다.",
          ogImage: supportHero,
          layoutType: "sub",
          heroTitle: "지원사업",
          heroSubtitle: "wayplus와 함께 새로운 도전을 해보세요 !",
          heroDescription: "당신의 기업이 더 빛날 수 있도록 웨이플러스가 돕겠습니다.",
          heroHeight: "large",
          showBreadcrumb: false
        }
      }
    ]
  },
  // 솔루션
  {
    path: "/solution",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    children: [
      {
        path: "together",
        name: "publicSolutionTogether",
        component: () => import("@/views/public/solution/SolutionTogether.vue"),
        meta: {
          title: "같이놀쟈",
          description: "같이놀쟈 — 웨이플러스의 솔루션 서비스입니다.",
          layoutType: "sub"
        }
      }
    ]
  },
  // 약관/방침
  {
    path: "/policy",
    component: () => import("@/layouts/public/PublicLayout.vue"),
    meta: { heroBgImage: technologyHero },
    children: [
      {
        path: "privacy",
        name: "policyPrivacy",
        component: () => import("@/views/public/policy/PolicyPrivacy.vue"),
        meta: {
          title: "개인정보처리방침",
          description: "웨이플러스 개인정보처리방침.",
          layoutType: "sub",
          heroTitle: "개인정보처리방침"
        }
      },
      {
        path: "terms",
        name: "policyTerms",
        component: () => import("@/views/public/policy/PolicyTerms.vue"),
        meta: {
          title: "이용약관",
          description: "웨이플러스 이용약관.",
          layoutType: "sub",
          heroTitle: "이용약관"
        }
      }
    ]
  }
];

export default publicRoutes;
